import logger from "./logger";
import i18n from "src/i18n";

/**
 * Render prediction boxes
 * @param {HTMLCanvasElement} canvasRef canvas tag reference
 * @param {Array} boxes_data boxes array
 * @param {Array} scores_data scores array
 * @param {Array} classes_data class array
 * @param {Array[Number]} ratios boxes ratio [xRatio, yRatio]
 */
export const renderBoxes = (canvasRef, boxes_data, scores_data, classes_data, ratios, threshold, carrierObj, generalLabels) => {
  const { frameDivRef, capture, setInformation, informationRef, countryAndModelControlName, setShowButton } = carrierObj
  if (frameDivRef.current === null) return;
  const frameDivRect = frameDivRef.current.getBoundingClientRect();
  const canvasRect = canvasRef.getBoundingClientRect();
  const canvasWidthRatio = 640 / canvasRect.width
  const canvasHeightRatio = 640 / canvasRect.height
  const borderPoints = {
    x1: (frameDivRect.x - canvasRect.x) * canvasWidthRatio,
    y1: (frameDivRect.y - canvasRect.y) * canvasHeightRatio,
    x2: ((frameDivRect.x - canvasRect.x) + frameDivRect.width) * canvasWidthRatio,
    y2: ((frameDivRect.y - canvasRect.y) + frameDivRect.height) * canvasHeightRatio
  }
  const xDistance = borderPoints.x2 - borderPoints.x1
  const yDistance = borderPoints.y2 - borderPoints.y1
  const frameBorderPointsDistance = Math.sqrt(xDistance * xDistance + yDistance * yDistance)

  const ctx = canvasRef.getContext("2d");
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height); // clean canvas

  //const colors = new Colors();

  // font configs
  const font = `${Math.max(
    Math.round(Math.max(ctx.canvas.width, ctx.canvas.height) / 40),
    14
  )}px Arial`;
  ctx.font = font;
  ctx.textBaseline = "top";

  for (let i = 0; i < scores_data.length; ++i) {
    if (scores_data[i] > threshold) {

      // filter based on class threshold
      const klass = generalLabels[classes_data[i]];

      if (klass === "not_valid") {
        setInformation(i18n.t("takePhoto.feedback.invalid"))
        continue
      }

      // Skip if class doesn't match - DON'T draw corners for non-matching classes
      if (klass !== countryAndModelControlName) {
        setShowButton(false)
        setInformation(i18n.t("takePhoto.feedback.notMatching"))
        continue
      }

      const score = (scores_data[i] * 100).toFixed(1);

      let [y1, x1, y2, x2] = boxes_data.slice(i * 4, (i + 1) * 4);
      x1 *= ratios[0];
      x2 *= ratios[0];
      y1 *= ratios[1];
      y2 *= ratios[1];
      const width = x2 - x1;
      const height = y2 - y1;
      const pointsDistance = Math.sqrt(width * width + height * height)

      // Draw corners ONLY for matching class
      drawCorners(ctx, x1, y1, width, height, "white");

      //logger.log(countryAndModelControlName);
      //logger.log(klass);

      if (klass !== countryAndModelControlName) {
        setShowButton(false)
        setInformation(i18n.t("takePhoto.feedback.notMatching"))
        continue
      }

      if (x1 > borderPoints.x1 && x1 < borderPoints.x2 && y1 > borderPoints.y1 && y1 < borderPoints.y2 && x2 > borderPoints.x1 && x2 < borderPoints.x2 && y2 > borderPoints.y1 && y2 < borderPoints.y2) {
        if (frameBorderPointsDistance * 0.865 <= pointsDistance) {
          setShowButton(true)
          if (informationRef.current !== i18n.t("takePhoto.feedback.done")) capture()
          setInformation(i18n.t("takePhoto.feedback.done"))
        } else if (frameBorderPointsDistance * 0.85 <= pointsDistance) {
          setShowButton(true)
          setInformation(i18n.t("takePhoto.feedback.keepSteady"))
        } else if (frameBorderPointsDistance * 0.78 <= pointsDistance) {
          setShowButton(true)
          setInformation(i18n.t("takePhoto.feedback.moveCloser"))
        } else {
          setShowButton(false)
          setInformation(i18n.t("takePhoto.feedback.moveItCloser"))
        }
      } else {
        setShowButton(false)
        setInformation(i18n.t("takePhoto.feedback.moveItAway"))
      }

      logger.log(klass + " - " + score + "%");
      //logger.log(countryAndModelControlName);

      //ctx.fillRect((frameDivRect.x - canvasRect.x) * canvasWidthRatio, (frameDivRect.y - canvasRect.y) * canvasHeightRatio, frameDivRect.width * canvasWidthRatio, frameDivRect.height * canvasHeightRatio);

      // // Draw the label background.
      // ctx.fillStyle = color;
      // const textWidth = ctx.measureText(klass + " - " + score + "%").width;
      // const textHeight = parseInt(font, 10); // base 10
      // const yText = y1 - (textHeight + ctx.lineWidth);
      // ctx.fillRect(
      //   x1 - 1,
      //   yText < 0 ? 0 : yText, // handle overflow label box
      //   textWidth + ctx.lineWidth,
      //   textHeight + ctx.lineWidth
      // );

      // // Draw labels
      //ctx.fillStyle = "#ffffff";
      //ctx.fillText(klass + " - " + score + "%", x1 - 1, yText < 0 ? 0 : yText);
    }
  }
};

class Colors {
  // ultralytics color palette https://ultralytics.com/
  constructor() {
    this.palette = [
      "#FF3838",
      "#FF9D97",
      "#FF701F",
      "#FFB21D",
      "#CFD231",
      "#48F90A",
      "#92CC17",
      "#3DDB86",
      "#1A9334",
      "#00D4BB",
      "#2C99A8",
      "#00C2FF",
      "#344593",
      "#6473FF",
      "#0018EC",
      "#8438FF",
      "#520085",
      "#CB38FF",
      "#FF95C8",
      "#FF37C7",
    ];
    this.n = this.palette.length;
  }

  get = (i) => this.palette[Math.floor(i) % this.n];

  static hexToRgba = (hex, alpha) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? `rgba(${[parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)].join(
        ", "
      )}, ${alpha})`
      : null;
  };
}
function drawCorners(ctx, x1, y1, width, height, color) {
  const cornerLength = 20; // Adjust the length of the corner lines as needed
  const lineWidth = Math.max(Math.min(ctx.canvas.width, ctx.canvas.height) / 200, 2.5);

  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;

  // Top-left corner
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x1 + cornerLength, y1);
  ctx.moveTo(x1, y1);
  ctx.lineTo(x1, y1 + cornerLength);
  ctx.stroke();

  // Top-right corner
  ctx.beginPath();
  ctx.moveTo(x1 + width, y1);
  ctx.lineTo(x1 + width - cornerLength, y1);
  ctx.moveTo(x1 + width, y1);
  ctx.lineTo(x1 + width, y1 + cornerLength);
  ctx.stroke();

  // Bottom-left corner
  ctx.beginPath();
  ctx.moveTo(x1, y1 + height);
  ctx.lineTo(x1 + cornerLength, y1 + height);
  ctx.moveTo(x1, y1 + height);
  ctx.lineTo(x1, y1 + height - cornerLength);
  ctx.stroke();

  // Bottom-right corner
  ctx.beginPath();
  ctx.moveTo(x1 + width, y1 + height);
  ctx.lineTo(x1 + width - cornerLength, y1 + height);
  ctx.moveTo(x1 + width, y1 + height);
  ctx.lineTo(x1 + width, y1 + height - cornerLength);
  ctx.stroke();
}

